import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import NumbersForm from './NumbersForm'
import { push } from 'react-router-redux'
import { getAvailable1300Numbers } from 'features/Numbers1300/Numbers1300.actions'
import { getAvailable1800Numbers } from 'features/Numbers1800/Numbers1800.actions'
import { createNumber } from 'features/Numbers/Numbers.actions'

const stateToProps = (
  { form, numbers1300, numbers1800, auth },
  {
    numberType,
    premiumNumber,
    standardNumber,
    numberWithLetters,
    numberSelected,
    premiumNumberMonthlyFee,
  }
) => {
  const formName = numberType === '1300' ? 'numbers1300' : 'numbers1800'
  return {
    isLoggedIn: !!auth.token,
    form: formName,
    formData: get(form, `${formName}.values`, {}),
    availableNumbers:
      numberType === '1300' ? numbers1300.availableNumbers : numbers1800.availableNumbers,
    initialValues: {
      step: 0,
      lastEdited: '',
      productId: undefined,
      ban: undefined,
      number: premiumNumber || standardNumber,
      numberWithLetters,
      numberSelected,
      premiumNumberMonthlyFee,
      forwardingNumber: undefined,
      isPremiumNumber: !!premiumNumber,
      isNewNumber: true,
      isExistingNumberInActive: false,
      existingNumberProvider: undefined,
      existingNumberAccount: undefined,
      proofOfPurchase: {
        id: undefined,
        name: undefined,
      },
      customerReference: undefined,
    },
  }
}

const dispatchToProps = {
  createNumber,
  getAvailable1300Numbers,
  getAvailable1800Numbers,
  push,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(NumbersForm)
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersForm/NumbersForm.container.js